import Store from '@/store/store';

export const moduleLoader = {
	state() {
		return {
			loaderShow: false,

			myfxSave: false,
			myfxViewLoader: false,
			pitLoader: false,
			pitAccept: false,
			poolRefillLoader: false,
			accountListLoader: false,

			initLoader: true,
		};
	},
	mutations: {
		setLoaderShow: (state) => {
			state.loaderShow = true;
		},
		setMyfxSave: (state, value) => (state.myfxSave = value),
		setMyfxViewLoader: (state, value) => (state.myfxViewLoader = value),
		setPitLoader: (state, value) => (state.pitLoader = value),
		setPitAccept: (state, value) => (state.pitAccept = value),
		setPoolRefillLoader: (state, value) => (state.poolRefillLoader = value),
		setAccountListLoader: (state, value) =>
			(state.accountListLoader = value),
		setInitLoader: (state, value) => (state.initLoader = value),
	},
	getters: {
		getInitLoader: (state) => state.initLoader,
		getMyfxViewLoader: (state) => state.myfxViewLoader,
		getLoaderShow: (state) => {
			return (
				Store.getters['getLoginLoader'] ||
				Store.getters['getUserDataLoader'] ||
				Store.getters['getAddresDictionaryLoader'] ||
				Store.getters['getTaxDictionaryLoader'] ||
				Store.getters['getMyAccountLoader'] ||
				Store.getters['getBankAccountListLoader'] ||
				Store.getters['getPayoutLoader'] ||
				Store.getters['getTrainingListLoader'] ||
				state.pitLoader ||
				state.poolRefillLoader ||
				state.accountListLoader ||
				Store.getters['getLearningLoader'] ||
				Store.getters['getLoadingSettings'] ||
				Store.getters['getMyfxViewLoader']
			);
		},
	},
};
